import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Button from "../../Common/Button";
import { format } from 'date-fns';
import Heading from "../../Common/Heading";
import { ic_search } from "../../Hotel/images";
import DatePicker from "react-datepicker";
import {captionIcon} from "../../img";
import "react-datepicker/dist/react-datepicker.css";
import CommonComponent from "../../Common/CommonComponent";
import { getBookingForReview, sendReviewMessage} from "../../Redux/Action";
import { columnBookingReviewList } from "../../Data/ColumnData";
import Loader from "../../Loader";

function BookingForReview() {
    const [startDateFilter, setStartDateFilter] = useState(new Date());
    const [endDateFilter, setEndDateFilter] = useState(new Date());
    const currentDate = new Date();
    const [startDateFilterValue, setStartDateFilterValue] = useState(format(currentDate, 'dd-MM-yyyy'));
    const [endDateFilterValue, setEndDateFilterValue] = useState(format(currentDate, 'dd-MM-yyyy'));
    const [triggerSearch, setTriggerSearch] = useState(false);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    let itemsPerPage = 10;
    let currentPageNo = 1;
    itemsPerPage = parseInt((searchParams.get("perPage"))?searchParams.get("perPage"):itemsPerPage);
    currentPageNo = parseInt((searchParams.get("page"))?searchParams.get("page"):currentPageNo);
    const [searchValue, setSearchValue] = useState("");
    const [selectedBooking, setSelectedBooking] = useState([]);
    const [loading, setLoading] = useState(false);

    const onDateFilterChange = (filed, value) => {
        let newValue = value;
        if (value instanceof Date) {
            newValue = format(value, 'dd-MM-yyyy');
            if(filed === 'startDate'){
                setStartDateFilterValue(newValue);
                setStartDateFilter(value);
            }
            else{
                setEndDateFilter(value);
                setEndDateFilterValue(newValue);
            }
        }
    };

    const handleSearchClick = () => {
        setTriggerSearch(!triggerSearch);
    };

    const handleCheckboxChange = (e, bookingId) => {
		if (e.target.checked) {
			setSelectedBooking((prev) => [...prev, bookingId]);
		} else {
			setSelectedBooking((prev) => prev.filter((id) => id !== bookingId));
		}
	};

    const handleSelectAll = (checked, displayed) => {
        if (checked) {
            const ids = (displayed || []).map(d => d._id);
            setSelectedBooking(ids);
        } else {
            setSelectedBooking([]);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = {};
        formData.selectedBookingIds = selectedBooking;
        try {
            setLoading(true);
            const response = await sendReviewMessage(formData);
            if(response){
                setTriggerSearch(!triggerSearch);
            }
        } catch (error) {
            setLoading(false);
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <div className="rounded-3xl bg-white pb-5 max-h-full overflow-hidden mx-1 sm:mx-3">
            {
				loading && (
					<Loader />
				)
			}
            <div className="px-5 py-3">
                <div className="flex justify-between items-center gap-3 pb-3    ">
                    <Heading title="Booking For Review"/>
                    <div className="flex gap-5 items-center">
                        <div className="relative">
                            <div className="absolute inset-y-5 start-1 flex items-center ps-3 pointer-events-none">
                                <img src={captionIcon} alt="icon" className="h-5"/>
                            </div>
                            <DatePicker name="dateFilter" selected={startDateFilter} className="placeholder:text-thirdColor peer w-full rounded-2xl border border-blue-gray-200  bg-transparent px-3 py-2 font-sans text-sm text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-1 focus:border-primary focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50 focus:placeholder:opacity-100 pl-10 items-center text-primary font-semibold"  dateFormat="dd MMM, yyyy" onChange={(date) => {onDateFilterChange('startDate',date);}} minDate={null} maxDate={endDateFilter || null}/>
                        </div>
                        <span className="font-semibold">TO</span>
                        <div className="relative">
                            <div className="absolute inset-y-5 start-1 flex items-center ps-3 pointer-events-none">
                                <img src={captionIcon} alt="icon" className="h-5"/>
                            </div>
                            <DatePicker name="dateFilter" selected={endDateFilter} className="placeholder:text-thirdColor peer w-full rounded-2xl border border-blue-gray-200  bg-transparent px-3 py-2 font-sans text-sm text-blue-gray-700 outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-blue-gray-200 placeholder-shown:border-t-blue-gray-200 focus:border-1 focus:border-primary focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50 focus:placeholder:opacity-100 pl-10 items-center text-primary font-semibold"  dateFormat="dd MMM, yyyy" onChange={(date) => {onDateFilterChange('endDate',date);}} minDate={startDateFilter || null} maxDate={null}/>
                        </div>
                        <Button
                            img={<img src={ic_search} alt="SOU-Hotel_search" className="aspect-square" />}
                            btn=""
                            btnPadding={"py-2 px-2.5"}
                            textColor={"text-white"}
                            bgColor={"bg-primary"}
                            btnRound={"rounded-xl"}
                            onClick={handleSearchClick}
                        />
                        {
                            selectedBooking.length > 0 && (
                                <button className="py-2 px-12 text-white bg-primary rounded-lg mt-2" onClick={handleSubmit}>Send Review Message</button>
                            )
                        }
                    </div>
                </div>
                <hr className="mb-3" />
                <div className="rounded-3xl bg-white pb-5 max-h-full">
                    <CommonComponent
                        title=""
                        apiFunction={getBookingForReview}
                        dataMapper={() => ({})}
                        columns={columnBookingReviewList(handleCheckboxChange, selectedBooking)}
                        addButtonLabel=""
                        bookingOnOff=""
                        contentName="BookingForReview"
                        urlName=""
                        itemsPerPage={itemsPerPage}
                        currentPageNo={currentPageNo}
                        showActionButtons={false}
                        showSettingButton={false}
                        showPageDetails={false}
                        showstatusToggel={false}
                        showTableTitle={false}
                        refresh={false}
                        searchValue={searchValue}
                        searchStartDate={startDateFilterValue}
                        searchEndDate={endDateFilterValue}
                        triggerSearch={triggerSearch}
                        // selection props
                        selectedItems={selectedBooking}
                        onSelectAll={handleSelectAll}
                        selectionEnabled={true}
                    />
                </div>
            </div>
        </div>
    );
}

export default BookingForReview;